import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GasObjectFilterPipe } from './gas-object-filter.pipe';

const PIPES = [
  GasObjectFilterPipe,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    PIPES,
  ],
  exports: [
    PIPES,
  ],
})
export class GasObjectFilterModule { }
